const Logo = (props) => (
  <img
    alt="Logo"
    src="/static/logo.svg"
    height={40}
    {...props}
  />
);

export default Logo;
